"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureCardLayoutArrangementArray = exports.FeatureCardLayoutArray = exports.FeatureCardThemeArray = exports.FeatureCardLayoutArrangement = exports.FeatureCardLayout = exports.FeatureCardTheme = void 0;
var FeatureCardTheme;
exports.FeatureCardTheme = FeatureCardTheme;

(function (FeatureCardTheme) {
  FeatureCardTheme["WHITE"] = "white";
  FeatureCardTheme["SEASHELL"] = "seashell";
  FeatureCardTheme["MOCASSIN"] = "mocassin";
  FeatureCardTheme["CLARET"] = "claret";
  FeatureCardTheme["BLACK"] = "black";
})(FeatureCardTheme || (exports.FeatureCardTheme = FeatureCardTheme = {}));

var FeatureCardLayout;
exports.FeatureCardLayout = FeatureCardLayout;

(function (FeatureCardLayout) {
  FeatureCardLayout["INLINE"] = "inline";
  FeatureCardLayout["OFFSET"] = "offset";
})(FeatureCardLayout || (exports.FeatureCardLayout = FeatureCardLayout = {}));

var FeatureCardLayoutArrangement;
exports.FeatureCardLayoutArrangement = FeatureCardLayoutArrangement;

(function (FeatureCardLayoutArrangement) {
  FeatureCardLayoutArrangement["IMG_LEFT"] = "img_left";
  FeatureCardLayoutArrangement["IMG_RIGHT"] = "img_right";
})(FeatureCardLayoutArrangement || (exports.FeatureCardLayoutArrangement = FeatureCardLayoutArrangement = {}));

var FeatureCardThemeArray = Object.values(FeatureCardTheme);
exports.FeatureCardThemeArray = FeatureCardThemeArray;
var FeatureCardLayoutArray = Object.values(FeatureCardLayout);
exports.FeatureCardLayoutArray = FeatureCardLayoutArray;
var FeatureCardLayoutArrangementArray = Object.values(FeatureCardLayoutArrangement);
exports.FeatureCardLayoutArrangementArray = FeatureCardLayoutArrangementArray;